import client from '../httpClient';

const directInfo = (customerId, params) => {
  return client.get(`/directs/information/${customerId}`, { params });
};

export default directInfo;
